<template>
    <v-dialog v-if="estimate" max-width="480px" v-model="show">
        <v-card class="estimate-1">
            <v-card-title class="subtitle-1">
                기본견적
                <v-spacer />
            </v-card-title>
            <v-card-text>
                <v-responsive width="100%">
                    <v-row align="end">
                        <v-col>
                            <v-text-field :value="`${estimate.totalAmount.format()} 원`" label="최종금액" placeholder=" " hide-details ></v-text-field>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn :href="estimate.file.name" target="_blank" color="primary"><v-icon>content-save</v-icon> 파일 보기</v-btn>
                        </v-col>
                    </v-row>
                </v-responsive>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="close()">{{ editable ? "취소" : "닫기" }}</v-btn>
                <v-btn v-if="editable" color="primary" text @click="save()">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: { type: Object, default: null },
        editable: { type: Boolean, default: true },
    },
    data() {
        return {
            show: false,
            estimate: null,
        };
    },
    methods: {
        open() {
            this.show = true;
            this.$set(this.$data, "estimate", JSON.parse(JSON.stringify(this.value)));
            this.estimate = {
                discountType: "none",
                discountRate: 0,
                ...this.estimate,
                file: this.value.file,
            };
        },
        close() {
            this.show = false;
            if (!this.editable) this.$emit("resetEstimate");
        },
        save() {
            this.$emit("input", this.estimate);
            this.show = false;
        },
    },
};
</script>

<style>
.estimate-1 .v-input input {
    text-align: center;
}
</style>
